module.exports = __webpack_public_path__ + "63c5c3808fe4097f245520d654869800.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/mobile_value_of_technology.png
// module id = 560
// module chunks = 0